export default __webpack_public_path__ + "static/media/landing-page-head-7.0db9824f.webp";